<template>
    <Drawer width="440" @on-close="closeDrawer" placement="right" :closable="false" v-model="isShow">
        <div class="page-title">
            <title-text :inline="true" :onlyText="false">{{ obj.title }}</title-text>
        </div>
        <Divider />
        <div class="drawer-content">
            <p>请开启需要的属性项</p>
            <div class="option-group margin-tb-20" v-for="item in obj.attrList" :key="item.code">
                <span class="label-width">{{ item.name }}</span>
                <i-switch class="margin-lr-20" v-model="item.enable" @on-change="changeSwitch(item)">显示</i-switch>
                <Checkbox v-show="item.enable" :disabled="Number(item.type) !== 1" class="label-true-display margin-lr-10" v-model="item.isDisplay" @on-change="changeSwitch(item)">显示</Checkbox>
                <Checkbox v-show="item.enable" class="label-true-display margin-lr-10" v-model="item.required" @on-change="changeSwitch(item)">必填</Checkbox>
                <Checkbox v-show="item.enable" :disabled="Number(item.type) !== 1" class="label-true-display margin-lr-10" v-model="item.isOnly" @on-change="changeSwitch(item)">唯一</Checkbox>
                <Icon v-show="item.code !== 'sex'" type="ios-create" size="20" class="is-display cursor-point theme-color" @click="openEditAttrDialog(item)"></Icon>
            </div>
        </div>
        <update-attr-info-dialog :obj="updateAttrObj" @closeDialog="handleCloseUpdateDialog"></update-attr-info-dialog>
    </Drawer>
</template>

<script>
import UpdateAttrInfoDialog from './updateAttrInfoDialog.vue'
import api from '../../../common/api'

export default {
    name: 'UpdateUserAttrDialog',
    props: {
        obj: {
            type: Object,
            required: true
        }
    },
    watch: {
        'obj.isShow': function (val) {
            this.isShow = val
        }
    },
    components: {
        UpdateAttrInfoDialog
    },
    data() {
        return {
            isShow: false,
            curItem: {},
            updateAttrObj: {
                isShow: false,
                title: '修改属性',
                data: {}
            }
        }
    },
    methods: {
        closeDrawer() {
            this.$emit('closeDialog')
        },
        editUserAttr(params) {
            api.editUserAttr(params).then((res) => {
                console.log(res)
            })
        },
        changeSwitch(item) {
            const params = {
                enable: !item.enable ? '-1' : '0',
                isDisplay: !item.isDisplay ? '-1' : '0',
                id: item.id,
                required: !item.required ? '-1' : '0',
                isOnly: !item.isOnly ? '-1' : '0',
                name: item.name
            }
            this.editUserAttr(params)
        },
        handleCloseUpdateDialog(type, data) {
            if (type === 'confirm') {
                this.curItem.name = data.name
                this.curItem.matchRule = data.matchRule
            }
            this.updateAttrObj.isShow = false
        },
        openEditAttrDialog(item) {
            this.curItem = item
            Object.assign(this.updateAttrObj, {
                isShow: true,
                data: {
                    id: item.id,
                    name: item.name,
                    type: item.type,
                    matchRule: item.matchRule
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
    .is-display {
        position: absolute;
        display: none;
        margin-left: 20px;
        right: 20px;

    }
    .label-width {
        width: 60px;
        display: inline-block;
    }
    .option-group:hover {
        .is-display {
            display: initial;
        }
    }
    .option-group {
        line-height: 20px;
    }
</style>
